import { typoM } from '../../../../../pages/selections/styles';

export const styles = {
  paperStyles: {
    padding: '4px 0',
    '& ul': {
      overflowY: 'auto',
    },
    '& .add-new': {
      padding: '0',
      borderTop: '1px solid #F3F4F9',
      lineHeight: 'normal',
      height: '48px',
    },
    '& .additional-option': {
      padding: '0',
      borderTop: '1px solid #F3F4F9',
      lineHeight: 'normal',
      height: '48px',
    },
    '& .add-new-btn': {
      padding: '13px 16px',
      ...typoM,
      color: '#4D6EF5',
      textTransform: 'capitalize',
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        '& svg': {
          width: '16px',
          height: '16px',
        },
      },
      '&:hover, &:focus, &:active': {
        background: 'transparent',
      },
    },
    '& .additional-option-btn': {
      padding: '13px 16px',
      ...typoM,
      color: '#4D6EF5',
      textTransform: 'capitalize',
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        '& svg': {
          width: '16px',
          height: '16px',
        },
      },
      '&:hover, &:focus, &:active': {
        background: 'transparent',
      },
    },
  },
};
